import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type User from "./User";

@Model()
class AudienceReport extends ApplicationRecord {
  static jsonapiType = "audience_reports";

  @Attr({ persist: false }) after: number;

  @Attr({ persist: false }) before: number;

  @Attr({ persist: false }) createdAt: string;

  @Attr({ persist: false }) csv: boolean;

  @Attr({ persist: false }) csvUrl: string;

  @Attr({ persist: false }) interval: string;

  @Attr({ persist: false }) pdf: boolean;

  @Attr({ persist: false }) pdfUrl: string;

  @BelongsTo() user: User;
}

export default AudienceReport;
